// extracted by mini-css-extract-plugin
export default {"selected":"Select_selected__v+JzS"};